<template>
  <div
    :class="[$style.container, { [$style.active]: isSelected }]"
    @click="handleClick"
    @mouseenter="handleMouseenter"
  >
    <!-- @slot Label of tab -->
    <slot />
  </div>
</template>

<script>
/**
 * Original Author: Dallin Anderson
 * Original Team: BFFs
 */
export default {
  name: 'NsTab',
  props: {
    isSelected: Boolean,
  },
  methods: {
    handleClick() {
      this.$emit('click');
    },
    handleMouseenter() {
      this.$emit('mouseenter');
    },
  },
};
</script>

<style lang="scss" module>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";
.container {
  align-items: center;
  display: flex;
  flex: 0 1 auto;
  font-size: 15px;
  font-weight: 400;
  justify-content: center;
  // letter-spacing: 0.0892857143em;
  line-height: normal;
  min-width: 60px;
  max-width: 360px;
  outline: none;
  padding: 0 18px;
  position: relative;
  color: inherit;
  text-align: center;
  text-decoration: none;
  // text-transform: uppercase;
  transition: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  white-space: normal;
  cursor: pointer;

  &:not(.active) {
    color: map.get(colors.$themeColors, color-interactive-8);
  }
}
</style>
